// ─── Auth helpers ────────────────────────────────────────────────────
// Equivalente di auth_utils.py — ma senza token manuali.
// Supabase JS gestisce la sessione in local Storage automaticamente.

import { supabase } from './supabase'

/**
 * Carica il profilo utente dalla tabella dim_user.
 * Chiamato dopo login o al ripristino sessione.
 */
export async function fetchUserProfile(userId) {
  const base = 'nickname, is_admin, theme, language, id_league_default, avatar_settings'
  // id_competition_default (uomini/donne) arriva con sql/20261024100000: se la colonna non c'e' ancora si ricade sul profilo senza di essa
  let { data, error } = await supabase.from('dim_user').select(`${base}, id_competition_default`).eq('id_user', userId)
  if (error) ({ data, error } = await supabase.from('dim_user').select(base).eq('id_user', userId))

  if (error || !data || data.length === 0) return null
  return data[0]
}
/**
 * Login con email e password.
 * Restituisce { user, profile } oppure lancia un errore.
 */
export async function signIn(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password })
  if (error) throw new Error('Credenziali errate.')
  const profile = await fetchUserProfile(data.user.id)
  return { user: data.user, profile }
}

/**
 * Registrazione nuovo utente.
 */
export async function signUp(email, password, nickname) {
  const { error } = await supabase.auth.signUp({
    email,
    password,
    options: { data: { nickname } }
  })
  if (error) throw error
}

/**
 * Logout.
 */
export async function signOut() {
  await supabase.auth.signOut()
}

/**
 * Ripristina la sessione corrente (es. dopo F5).
 */
export async function getCurrentSession() {
  const { data: { session } } = await supabase.auth.getSession()
  if (!session?.user) return null
  const profile = await fetchUserProfile(session.user.id)
  return { user: session.user, profile }
}
